import { GlobalData } from "../Common/GlobalData";
import { TemplateHelpers } from "../Common/KendoHelpers";

export class CompanyReports {
    public static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(CompanyReports.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_VALUE_LINE_COMPANY_REPORTS
                },
                batch: true,
                serverPaging: false,
                serverSorting: false,
            },

            height: 915,
            groupable: false,
            editable: false,
            navigatable: false,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '24%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: 'personalIssueNumber',
                    title: 'Personal<br>Issue',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'personalDateOfIssue',
                    title: 'Personal<br>Date',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('personalDateOfIssue')),
                },
                {
                    field: 'personalUrl',
                    title: 'Personal<br>Report',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getValueLineReportTemplate('personalUrl')),
                },
                {
                    field: 'originalIssueNumber',
                    title: 'Original<br>Issue',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'originalDateOfIssue',
                    title: 'Original<br>Date',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('originalDateOfIssue')),
                },
                {
                    field: 'originalUrl',
                    title: 'Original<br>Report',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getValueLineReportTemplate('originalUrl')),
                },
            ]
        }).data('kendoGrid');
    }
}
